import * as THREE from "three";

function exportThreeObj(dataElement) {
  return dataElement.dataElementThreeObject;
}

export const mousePositionWatcher = function(event, mouse, window) {
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
};

export const getSelectObject = function(event, dataModel, camera, window) {
  var raycaster = new THREE.Raycaster();
  var mouse = new THREE.Vector2();
  // get all three objects
  const allThreeObjs = [];

  dataModel.forEach(dataElement => {
    allThreeObjs.push(exportThreeObj(dataElement));
  });

  // get mouse coordinate
  mousePositionWatcher(event, mouse, window);

  // update
  raycaster.setFromCamera(mouse, camera);

  // calculate the intersection of line and mouse pointer
  const intersects = raycaster.intersectObjects(allThreeObjs);

  // return selected object
  if (intersects.length > 0) {
    const index = allThreeObjs.indexOf(intersects[0].object);
    return dataModel[index];
  }
};
